// Used in assignable-task-categories.component.ts

import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Bundle } from "@carnegie-learning/cure-types";

@Component({
    selector: "task-category-dialog",
    templateUrl: "./task-category-dialog.component.html",
    styleUrls: ["./task-category-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TaskCategoryDialogComponent {
    category: Bundle;

    constructor(
        private categoryDialogRef: MatDialogRef<TaskCategoryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: Bundle
    ) {
        this.category = data;
    }

    close() {
        this.categoryDialogRef.close();
    }
}
